module.exports = __webpack_public_path__ + "static/media/totalChart.62ab7477.png";